import {
  compare,
  IStringCompareOptions
} from '../primitiveHelpers/stringHelpers';

export const sortList: <T>(
  array: T[],
  property: string | ((obj: T) => string),
  options?: IStringCompareOptions
) => T[] = (array, property, options) => {
  const newList = array.slice();

  return newList.sort((a, b) => {
    const aValue = typeof property === 'function' ? property(a) : a[property];
    const bValue = typeof property === 'function' ? property(b) : b[property];

    return compare(aValue, bValue, options);
  });
};
